export default __webpack_public_path__ + "static/0300-503cf645473e3ae30159902bbf5f5400.png";